import gql from "graphql-tag";

export const allProductsQuery = gql`
  query AllProducts {
    products {
      id
      name
      modules {
        custom_tables {
          tools {
            builtin_id
            sort_no
            name
            url
            image
            primaryColor
            description_short
            visible
          }
        }
      }
    }
  }
`;

export const allToolsQuery = gql`
  query AllTools($productId: ID!) {
    product(id: $productId) {
      id
      name
      modules {
        custom_tables {
          tools {
            builtin_id
            sort_no
            name
            title
            url
            image
            primaryColor
            description_short
            visible
            category
          }
        }
      }
    }
  }
`;

export const productCarouselImagesQuery = gql`
  query ProductCarouselImages($productId: ID!) {
    product(id: $productId) {
      id
      name
      modules {
        properties {
          property {
            name
            values {
              property_filter
              image
            }
          }
        }
      }
    }
  }
`;

export const headerLinksQuery = gql`
  query HeaderLinks {
    products {
      id
      name
      modules {
        custom_tables {
          links {
            url
            name
            type
            sort_no
          }
        }
      }
    }
  }
`;

export const translationsQuery = gql`
  query Translations($language: String!) {
    products {
      id
      key
      name
      modules {
        texts {
          text(language: $language) {
            name
            text
          }
        }
      }
    }
  }
`;

export const heroImageQuery = gql`
  query HeroImage {
    products {
      id
      name
      modules {
        images {
          image {
            builtin_id
            sort_no
            image
            file_name
            property_filter
            type
            name
            size
          }
        }
      }
    }
  }
`;
